import React from 'react';
import Navigation from 'src/components/Navigation';
import { strataManagerTopLinks, sharedBottomLinks } from '../Constants';
import SidebarContextTree, {
  SidebarContextRow,
} from '../Components/SidebarContextTree';
import usePropertyContextRowsStrataManager from '../Hooks/usePropertyContextRowsStrataManager';
import { SidebarPermissionsData } from '../ModernSidebar';

interface StrataManagerSidebarNavProps {
  collapseSideBar: boolean;
  permissions: SidebarPermissionsData;
}

const CONTEXT_PRIORITY: string[] = ['properties'];

const StrataManagerSidebarNav = ({
  collapseSideBar,
}: StrataManagerSidebarNavProps) => {
  const rowsByContext: Record<string, SidebarContextRow[] | null> = {
    properties: usePropertyContextRowsStrataManager(),
  };

  const matchedContextId: string | undefined = CONTEXT_PRIORITY.find(
    (contextId: string): boolean => rowsByContext[contextId] !== null
  );

  const activeContextId: string | null = matchedContextId ?? null;

  const activeContextRows: SidebarContextRow[] | null = activeContextId
    ? rowsByContext[activeContextId]
    : null;

  if (!activeContextId || !activeContextRows || collapseSideBar) {
    return (
      <>
        <Navigation
          links={strataManagerTopLinks}
          collapseSideBar={collapseSideBar}
        />
        <div className="sidebar-spacer" />
        <Navigation
          links={sharedBottomLinks}
          collapseSideBar={collapseSideBar}
        />
      </>
    );
  }

  // Insert the context tree directly beneath its own top-nav link: split the links there.
  const activeLinkIndex: number = strataManagerTopLinks.findIndex(
    (link: any) => link.id === activeContextId
  );

  const linksThroughActive: any[] = strataManagerTopLinks.slice(
    0,
    activeLinkIndex + 1
  );

  const linksAfterActive: any[] = strataManagerTopLinks.slice(
    activeLinkIndex + 1
  );

  return (
    <>
      <Navigation
        links={linksThroughActive}
        collapseSideBar={collapseSideBar}
      />
      <SidebarContextTree rows={activeContextRows} />
      <Navigation links={linksAfterActive} collapseSideBar={collapseSideBar} />
      <div className="sidebar-spacer" />
      <Navigation links={sharedBottomLinks} collapseSideBar={collapseSideBar} />
    </>
  );
};

export default StrataManagerSidebarNav;